<template>
    <div class="pl-[20px] pr-[20px] pt-[20px]">
        <div class="h-[100%] rounded-[12px]">
            <div class="h-[auto] bg-[white] rounded-[12px] pt-[28px] pl-[28px] pr-[28px] flex flex-col justify-end ">
                <div>
                    <div class="flex justify-between">
                        <div class="flex">
                            <div>
                                <svg width="33" height="25" viewBox="0 0 33 25" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M27.9667 13.7804C27.6031 13.7804 27.2987 13.6577 27.0534 13.4124C26.8081 13.1672 26.6854 12.8627 26.6854 12.4992C26.6854 12.1356 26.8081 11.8312 27.0534 11.5859C27.2987 11.3406 27.6031 11.218 27.9667 11.218H31.5805C31.944 11.218 32.2485 11.3406 32.4938 11.5859C32.7391 11.8312 32.8617 12.1356 32.8617 12.4992C32.8617 12.8627 32.7391 13.1672 32.4938 13.4124C32.2485 13.6577 31.944 13.7804 31.5805 13.7804H27.9667ZM27.6152 24.5166L24.734 22.3516C24.434 22.1326 24.261 21.8528 24.215 21.5122C24.169 21.1717 24.2555 20.8514 24.4745 20.5513C24.6935 20.2513 24.9733 20.0783 25.3139 20.0323C25.6544 19.9863 25.9747 20.0728 26.2747 20.2918L29.1559 22.4568C29.456 22.6758 29.629 22.9556 29.675 23.2961C29.721 23.6367 29.6345 23.957 29.4155 24.2571C29.1965 24.5571 28.9167 24.7301 28.5761 24.7761C28.2355 24.8221 27.9152 24.7356 27.6152 24.5166ZM26.2091 4.64083C25.909 4.85984 25.5887 4.94635 25.2481 4.90037C24.9076 4.85436 24.6278 4.68133 24.4088 4.38129C24.1898 4.08125 24.1033 3.76096 24.1492 3.4204C24.1953 3.07984 24.3683 2.80005 24.6683 2.58101L27.5495 0.416038C27.8496 0.19703 28.1698 0.110517 28.5104 0.1565C28.851 0.202483 29.1307 0.375508 29.3498 0.675577C29.5688 0.975617 29.6553 1.29592 29.6093 1.63647C29.5633 1.97703 29.3903 2.25681 29.0903 2.47582L26.2091 4.64083ZM4.96996 23.5704V16.9014H3.22874C2.37679 16.9014 1.64911 16.5997 1.0457 15.9963C0.442316 15.3929 0.140625 14.6652 0.140625 13.8133V11.1851C0.140625 10.3331 0.442316 9.60545 1.0457 9.00204C1.64911 8.39865 2.37679 8.09696 3.22874 8.09696H9.83209L15.1443 4.92015C15.659 4.61134 16.1781 4.6086 16.7015 4.91194C17.225 5.21529 17.4867 5.66153 17.4867 6.25068V18.7477C17.4867 19.3368 17.225 19.783 16.7015 20.0864C16.1781 20.3897 15.659 20.387 15.1443 20.0782L9.83209 16.9014H7.53237V23.5704H4.96996ZM19.8521 17.8278V7.17049C20.5223 7.77718 21.0622 8.54154 21.4717 9.46359C21.8813 10.3857 22.0861 11.3975 22.0861 12.4992C22.0861 13.6008 21.8813 14.6127 21.4717 15.5347C21.0622 16.4568 20.5223 17.2212 19.8521 17.8278ZM14.9242 16.9146V8.08376L10.5417 10.6594H3.22874C3.09734 10.6594 2.97687 10.7142 2.86734 10.8237C2.75783 10.9332 2.70308 11.0537 2.70308 11.1851V13.8133C2.70308 13.9447 2.75783 14.0651 2.86734 14.1747C2.97687 14.2842 3.09734 14.3389 3.22874 14.3389H10.5417L14.9242 16.9146Z"
                                        fill="#003765" />
                                </svg>
                            </div>
                            <div class="text-[24px] font-bold ml-[8px] flex justify-center items-center">
                                ประกาศ
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-between mt-[8px]">
                        <div class="flex justify-between w-[100%]">
                            <div class="flex items-start">
                                <!-- Create announcement button with package limits -->
                                <div class="h-[36px] pl-[12px] pr-[12px] flex cursor-pointer justify-center rounded-[12px] mt-[12px]"
                                     :class="canCreateAnnouncement ? 'bg-[#003765]' : 'bg-gray-400 cursor-not-allowed'"
                                     @click="handleCreateAnnouncement">
                                    <div class="flex justify-center items-center">
                                        <svg width="14" height="13" viewBox="0 0 14 13" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M6.99968 12.6875C6.8048 12.6875 6.64155 12.6216 6.50993 12.4898C6.37831 12.3581 6.3125 12.1948 6.3125 12V7.18746H1.49998C1.30519 7.18746 1.14191 7.12155 1.01016 6.98973C0.878385 6.8579 0.8125 6.69455 0.8125 6.49968C0.8125 6.3048 0.878385 6.14155 1.01016 6.00993C1.14191 5.87831 1.30519 5.8125 1.49998 5.8125H6.3125V0.999977C6.3125 0.805185 6.37841 0.641904 6.51023 0.510133C6.64206 0.378378 6.80541 0.3125 7.00028 0.3125C7.19516 0.3125 7.35841 0.378378 7.49003 0.510133C7.62165 0.641904 7.68745 0.805185 7.68745 0.999977V5.8125H12.5C12.6948 5.8125 12.8581 5.87841 12.9898 6.01023C13.1216 6.14206 13.1875 6.30541 13.1875 6.50028C13.1875 6.69516 13.1216 6.85841 12.9898 6.99003C12.8581 7.12164 12.6948 7.18746 12.5 7.18746H7.68745V12C7.68745 12.1948 7.62155 12.3581 7.48973 12.4898C7.3579 12.6216 7.19455 12.6875 6.99968 12.6875Z"
                                                fill="white" />
                                        </svg>
                                    </div>
                                    <div class="text-white font-bold ml-[8px] flex justify-center items-center">
                                        สร้างประกาศ
                                    </div>
                                </div>
                                
                                <!-- Package limit indicator -->
                                <div class="ml-4 flex flex-col justify-center mt-[12px]">
                                    <div v-if="isBusinessPackage" class="text-xs text-gray-600">
                                        {{ currentMonthAnnouncementCount }}/{{ BUSINESS_PACKAGE_ANNOUNCEMENT_LIMIT }} ประกาศในเดือนนี้
                                    </div>
                                    <div v-if="isProPackage" class="text-xs text-green-600">
                                        ไม่จำกัดจำนวนประกาศ
                                    </div>
                                </div>
                                
                                <!-- Delete button -->
                                <div v-if="selected.length > 0" @click="confirmDeleteSelected()"
                                    class="h-[36px] pl-[12px] pr-[12px] bg-[#D44769] flex cursor-pointer justify-center rounded-[12px] mt-[12px] ml-[14px]">
                                    <div class="text-white font-bold flex justify-center items-center">ลบประกาศ</div>
                                </div>
                            </div>
                            
                            <!-- History button -->
                            <div @click="history_ann = true"
                                class="flex justify-center items-center border mt-[12px] h-[36px] pl-[12px] pr-[12px] rounded-[12px] cursor-pointer ">
                                <div class="flex justify-center items-center">
                                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M8.0104 16.2923C6.92874 16.2923 5.9156 16.0878 4.97096 15.6788C4.02632 15.2698 3.20261 14.714 2.49983 14.0112C1.79705 13.3084 1.24118 12.4848 0.832206 11.5402C0.423235 10.5957 0.21875 9.58266 0.21875 8.50113C0.21875 7.4196 0.423235 6.4064 0.832206 5.46154C1.24118 4.51667 1.79705 3.69284 2.49983 2.99006C3.20261 2.2873 4.02632 1.73143 4.97096 1.32246C5.9156 0.913478 6.92874 0.708984 8.0104 0.708984C9.16327 0.708984 10.2586 0.951374 11.2963 1.43615C12.334 1.92093 13.2248 2.60226 13.9687 3.48014V1.99582C13.9687 1.80103 14.0346 1.63775 14.1664 1.50598C14.2983 1.37421 14.4616 1.30832 14.6565 1.30832C14.8513 1.30832 15.0146 1.37421 15.1462 1.50598C15.2779 1.63775 15.3437 1.80103 15.3437 1.99582V5.1336C15.3437 5.36834 15.2643 5.56511 15.1055 5.72391C14.9466 5.88272 14.7499 5.96213 14.5151 5.96213H11.3774C11.1826 5.96213 11.0193 5.89621 10.8875 5.76438C10.7557 5.63255 10.6899 5.4692 10.6899 5.27433C10.6899 5.07945 10.7557 4.91619 10.8875 4.78458C11.0193 4.65296 11.1826 4.58715 11.3774 4.58715H13.0873C12.455 3.80798 11.7011 3.19599 10.8256 2.75118C9.95007 2.30637 9.01167 2.08396 8.0104 2.08396C6.22289 2.08396 4.70657 2.70653 3.46144 3.95167C2.2163 5.19681 1.59373 6.71313 1.59373 8.50063C1.59373 10.2881 2.2163 11.8044 3.46144 13.0496C4.70657 14.2947 6.22289 14.9173 8.0104 14.9173C9.49116 14.9173 10.8089 14.4628 11.9635 13.5538C13.1182 12.6447 13.87 11.4821 14.219 10.066C14.2778 9.87445 14.3815 9.72931 14.5302 9.63058C14.6788 9.53187 14.8469 9.49485 15.0344 9.51953C15.2335 9.54422 15.3875 9.63295 15.4962 9.78573C15.6049 9.93849 15.6345 10.1059 15.5852 10.2881C15.1892 12.0415 14.2884 13.4806 12.8828 14.6052C11.4773 15.7299 9.85312 16.2923 8.0104 16.2923ZM8.69787 8.2221L11.2187 10.743C11.3456 10.8699 11.4106 11.0294 11.4135 11.2215C11.4164 11.4137 11.3515 11.5762 11.2187 11.709C11.0859 11.8418 10.9249 11.9082 10.7357 11.9082C10.5465 11.9082 10.3855 11.8418 10.2527 11.709L7.57145 9.02771C7.48566 8.94191 7.4228 8.84843 7.38284 8.74726C7.34288 8.64609 7.32289 8.54155 7.32289 8.43364V4.60477C7.32289 4.41 7.38881 4.24672 7.52064 4.11495C7.65247 3.98318 7.81582 3.9173 8.01069 3.9173C8.20558 3.9173 8.36883 3.98318 8.50044 4.11495C8.63206 4.24672 8.69787 4.41 8.69787 4.60477V8.2221Z"
                                            fill="#003765" />
                                    </svg>
                                </div>
                                <div class="text-[14px] font-bold ml-[8px] flex justify-center items-center">ประวัติย้อยหลัง</div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- Main table -->
                <div class="center mt-[24px]">
                    <vs-table v-model="selected">
                        <template #thead>
                            <vs-tr>
                                <vs-th>
                                    <div class="flex">
                                        <div>
                                            <vs-checkbox :indeterminate="selected.length > 0 && selected.length < activeAnnouncements.length"
                                                v-model="allCheck"
                                                @change="selected = $vs.checkAll(selected, activeAnnouncements)" />
                                        </div>
                                        <div class="ml-[24px]">วันที่ประกาศ</div>
                                    </div>
                                </vs-th>
                                <vs-th>วันที่สิ้นสุด</vs-th>
                                <vs-th>หัวข้อ</vs-th>
                                <vs-th>เรื่องที่ประกาศ</vs-th>
                                <vs-th>รูปภาพ</vs-th>
                                <vs-th>ผู้สร้างประกาศ</vs-th>
                                <vs-th>จัดการ</vs-th>
                            </vs-tr>
                        </template>
                        <template #tbody>
                            <vs-tr :key="tr.id" v-for="tr in activeAnnouncements" :data="tr">
                                <vs-td checkbox>
                                    <div class="flex">
                                        <div>
                                            <vs-checkbox :val="tr" v-model="selected" />
                                        </div>
                                        <div class="text-custom ml-[24px]">{{ convertDateNoTime(tr.attributes.createdAt) }}</div>
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="text-custom">{{ convertDateNoTime(tr.attributes.date_execute) }}</div>
                                </vs-td>
                                <vs-td>
                                    <div class="text-custom">{{ tr.attributes.topic }}</div>
                                </vs-td>
                                <vs-td>
                                    <div class="text-custom">{{ tr.attributes.description }}</div>
                                </vs-td>
                                <vs-td>
                                    <div class="flex items-center">
                                        <img v-for="img in announcementImages(tr)" :key="img.id" :src="img.thumb"
                                            @click="previewImg(img.full)"
                                            class="h-[36px] w-[36px] object-cover rounded-[6px] border mr-[4px] cursor-pointer" />
                                        <span v-if="announcementImages(tr).length === 0" class="text-custom text-[#5C6B79]">-</span>
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="text-custom flex">
                                        <Avatar
                                            :src="tr.attributes.users_created && tr.attributes.users_created.data && tr.attributes.users_created.data.attributes.imageProfile && tr.attributes.users_created.data.attributes.imageProfile.data && tr.attributes.users_created.data.attributes.imageProfile.data.attributes.url"
                                            :name="tr.attributes.users_created && tr.attributes.users_created.data ? ((tr.attributes.users_created.data.attributes.firstName || '') + ' ' + (tr.attributes.users_created.data.attributes.lastName || '')) : ''"
                                            :size="32" />
                                        <div class="flex justify-center items-center ml-[8px]">
                                            {{ tr.attributes.users_created?.data?.attributes?.firstName }}
                                            {{ tr.attributes.users_created?.data?.attributes?.lastName }}
                                        </div>
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="flex items-center">
                                        <div @click.stop="openEditAnnouncement(tr)" title="แก้ไข"
                                            class="h-[32px] w-[32px] flex justify-center items-center rounded-[8px] bg-[#F3F8FD] cursor-pointer mr-[8px]">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4 20h4l10.5-10.5a2.121 2.121 0 0 0-3-3L5 17v3z" stroke="#003765" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                        <div @click.stop="confirmDeleteAnnouncement(tr)" title="ลบ"
                                            class="h-[32px] w-[32px] flex justify-center items-center rounded-[8px] bg-[#FBE9EE] cursor-pointer">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" stroke="#D44769" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                    </div>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                    <div v-if="activeAnnouncements.length === 0"
                        class="text-custom text-center text-[#5C6B79] py-[16px]">ยังไม่มีประกาศ</div>
                </div>
            </div>
        </div>

        <!-- Create Announcement Modal -->
        <b-modal centered v-model="create_ann" size="l" hide-backdrop hide-header-close hide-header hide-footer
            class="p-[-20px] text-custom">
            <div>
                <div class="flex justify-between pl-[20px] pr-[20px]">
                    <div class="text-custom flex justify-center items-center text-[18px] font-bold">สร้างประกาศ</div>
                    <div @click="create_ann = false" class="cursor-pointer">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_417_4814" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                width="24" height="24">
                                <rect width="24" height="24" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_417_4814)">
                                <path
                                    d="M12.0005 13.0538L6.92737 18.1269C6.78892 18.2654 6.61489 18.3362 6.40527 18.3394C6.19567 18.3426 6.01844 18.2718 5.87357 18.1269C5.72869 17.982 5.65625 17.8064 5.65625 17.6C5.65625 17.3936 5.72869 17.218 5.87357 17.0731L10.9466 12L5.87357 6.92689C5.73511 6.78844 5.66427 6.6144 5.66107 6.40479C5.65786 6.19519 5.72869 6.01795 5.87357 5.87309C6.01844 5.7282 6.19407 5.65576 6.40047 5.65576C6.60687 5.65576 6.78251 5.7282 6.92737 5.87309L12.0005 10.9462L17.0736 5.87309C17.212 5.73462 17.3861 5.66379 17.5957 5.66059C17.8053 5.65737 17.9825 5.7282 18.1274 5.87309C18.2723 6.01795 18.3447 6.19359 18.3447 6.39999C18.3447 6.60639 18.2723 6.78202 18.1274 6.92689L13.0543 12L18.1274 17.0731C18.2658 17.2115 18.3367 17.3856 18.3399 17.5952C18.3431 17.8048 18.2723 17.982 18.1274 18.1269C17.9825 18.2718 17.8069 18.3442 17.6005 18.3442C17.3941 18.3442 17.2184 18.2718 17.0736 18.1269L12.0005 13.0538Z"
                                    fill="#5C6B79" />
                            </g>
                        </svg>
                    </div>
                </div>
                <div class="pl-[20px] pr-[20px] mt-[24px]">
                    <div>
                        <div class="text-custom text-[14px] text-[#003765]">เรื่องที่ประกาศ *</div>
                        <input class="h-[28px] w-[100%] bg-[#F3F8FD] rounded-[12px] pl-[12px] pr-[12px] flex justify-start" type="input"
                            v-model="topic" />
                    </div>
                    <div class="mt-[14px]">
                        <div class="text-custom text-[14px] text-[#003765]">รายละเอียดการแจ้ง *</div>
                        <textarea class="h-[60px] w-[100%] bg-[#F3F8FD] rounded-[12px] pl-[12px] pr-[12px] pt-[8px] flex justify-start" type="input"
                            v-model="description" />
                    </div>
                    <div class="mt-[14px]">
                        <div class="text-custom text-[14px] text-[#003765]">วันที่สิ้นสุด *</div>
                        <DateField class="w-[100%]" v-model="date_execute" />
                    </div>
                    <div class="mt-[14px]">
                        <div class="text-custom text-[14px] text-[#003765]">รูปภาพ *</div>
                        <div class="flex mt-[4px]" v-if="image == ''">
                            <input class="h-[28px] w-[120px] rounded-[12px] border flex justify-start" id="upload"
                                @change="previewImage" type="file" accept="image/*" hidden />
                            <label for="upload">
                                <div
                                    class="h-[28px] w-[120px] flex justify-center text-custom items-center bg-[#165D98] text-[14px] text-[white] rounded-[12px] cursor-pointer">
                                    อัพโหลดรูปภาพ</div>
                            </label>
                            <div class="text-[#5C6B79] text-custom flex justify-center items-center ml-[8px] text-[12px]">
                                ยังไม่ได้เลือกไฟล์</div>
                        </div>
                        <div class="flex mt-[4px]" v-else>
                            <div @click="previewImg(image_e)"
                                class="text-[#5C6B79] text-custom flex justify-center items-center text-[12px] cursor-pointer">
                                {{ image_name }}</div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-end mt-[30px]">
                    <div>
                        <vs-button dark shadow :disabled="creating" @click="create_ann = false">
                            <div class="text-custom">ยกเลิก</div>
                        </vs-button>
                    </div>
                    <div>
                        <vs-button :loading="creating" @click="createAnnouncement()" color="#003765">
                            <div class="text-custom">ประกาศ</div>
                        </vs-button>
                    </div>
                </div>
            </div>
        </b-modal>

        <!-- Edit Announcement Modal -->
        <b-modal centered v-model="edit_ann" size="l" hide-backdrop hide-header-close hide-header hide-footer
            class="p-[-20px] text-custom">
            <div>
                <div class="flex justify-between pl-[20px] pr-[20px]">
                    <div class="text-custom flex justify-center items-center text-[18px] font-bold">แก้ไขประกาศ</div>
                    <div @click="edit_ann = false" class="cursor-pointer">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12.0005 13.0538L6.92737 18.1269C6.78892 18.2654 6.61489 18.3362 6.40527 18.3394C6.19567 18.3426 6.01844 18.2718 5.87357 18.1269C5.72869 17.982 5.65625 17.8064 5.65625 17.6C5.65625 17.3936 5.72869 17.218 5.87357 17.0731L10.9466 12L5.87357 6.92689C5.73511 6.78844 5.66427 6.6144 5.66107 6.40479C5.65786 6.19519 5.72869 6.01795 5.87357 5.87309C6.01844 5.7282 6.19407 5.65576 6.40047 5.65576C6.60687 5.65576 6.78251 5.7282 6.92737 5.87309L12.0005 10.9462L17.0736 5.87309C17.212 5.73462 17.3861 5.66379 17.5957 5.66059C17.8053 5.65737 17.9825 5.7282 18.1274 5.87309C18.2723 6.01795 18.3447 6.19359 18.3447 6.39999C18.3447 6.60639 18.2723 6.78202 18.1274 6.92689L13.0543 12L18.1274 17.0731C18.2658 17.2115 18.3367 17.3856 18.3399 17.5952C18.3431 17.8048 18.2723 17.982 18.1274 18.1269C17.9825 18.2718 17.8069 18.3442 17.6005 18.3442C17.3941 18.3442 17.2184 18.2718 17.0736 18.1269L12.0005 13.0538Z"
                                fill="#5C6B79" />
                        </svg>
                    </div>
                </div>
                <div class="pl-[20px] pr-[20px] mt-[24px]">
                    <div>
                        <div class="text-custom text-[14px] text-[#003765]">เรื่องที่ประกาศ *</div>
                        <input class="h-[28px] w-[100%] bg-[#F3F8FD] rounded-[12px] pl-[12px] pr-[12px] flex justify-start" type="input"
                            v-model="editTopic" />
                    </div>
                    <div class="mt-[14px]">
                        <div class="text-custom text-[14px] text-[#003765]">รายละเอียดการแจ้ง *</div>
                        <textarea class="h-[60px] w-[100%] bg-[#F3F8FD] rounded-[12px] pl-[12px] pr-[12px] pt-[8px] flex justify-start" type="input"
                            v-model="editDescription" />
                    </div>
                    <div class="mt-[14px]">
                        <div class="text-custom text-[14px] text-[#003765]">วันที่สิ้นสุด *</div>
                        <DateField class="w-[100%]" v-model="editDateExecute" />
                    </div>
                    <div class="mt-[14px]">
                        <div class="text-custom text-[14px] text-[#003765]">รูปภาพ</div>
                        <div class="flex items-center mt-[4px]">
                            <img v-for="img in editExistingImages" :key="img.id" :src="img.thumb"
                                @click="previewImg(img.full)"
                                class="h-[40px] w-[40px] object-cover rounded-[6px] border mr-[4px] cursor-pointer" />
                            <span v-if="editExistingImages.length === 0" class="text-[#5C6B79] text-custom text-[12px]">ยังไม่มีรูปภาพ</span>
                        </div>
                        <div class="flex items-center mt-[8px]" v-if="!editNewImage">
                            <input class="hidden" id="edit-upload" @change="previewEditImage" type="file" accept="image/*" hidden />
                            <label for="edit-upload">
                                <div class="h-[28px] pl-[12px] pr-[12px] flex justify-center text-custom items-center bg-[#165D98] text-[14px] text-[white] rounded-[12px] cursor-pointer">
                                    เพิ่มรูปภาพ</div>
                            </label>
                        </div>
                        <div class="flex items-center mt-[8px]" v-else>
                            <div @click="previewImg(editNewImagePreview)"
                                class="text-[#5C6B79] text-custom text-[12px] cursor-pointer">{{ editNewImageName }}</div>
                            <div @click="clearEditNewImage()" class="text-[#D44769] text-custom text-[12px] cursor-pointer ml-[8px]">ลบ</div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-end mt-[30px]">
                    <div>
                        <vs-button dark shadow :disabled="saving" @click="edit_ann = false">
                            <div class="text-custom">ยกเลิก</div>
                        </vs-button>
                    </div>
                    <div>
                        <vs-button :loading="saving" @click="updateAnnouncement()" color="#003765">
                            <div class="text-custom">บันทึก</div>
                        </vs-button>
                    </div>
                </div>
            </div>
        </b-modal>

        <!-- History Modal -->
        <b-modal centered v-model="history_ann" size="xl" hide-backdrop hide-header-close hide-header hide-footer
            class=" text-custom">
            <div>
                <div class="flex justify-between p-[20px]">
                    <div class="text-custom flex justify-center items-center text-[18px] font-bold">ประวัติย้อนหลัง</div>
                    <div @click="history_ann = false" class="cursor-pointer">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_417_4814" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                width="24" height="24">
                                <rect width="24" height="24" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_417_4814)">
                                <path
                                    d="M12.0005 13.0538L6.92737 18.1269C6.78892 18.2654 6.61489 18.3362 6.40527 18.3394C6.19567 18.3426 6.01844 18.2718 5.87357 18.1269C5.72869 17.982 5.65625 17.8064 5.65625 17.6C5.65625 17.3936 5.72869 17.218 5.87357 17.0731L10.9466 12L5.87357 6.92689C5.73511 6.78844 5.66427 6.6144 5.66107 6.40479C5.65786 6.19519 5.72869 6.01795 5.87357 5.87309C6.01844 5.7282 6.19407 5.65576 6.40047 5.65576C6.60687 5.65576 6.78251 5.7282 6.92737 5.87309L12.0005 10.9462L17.0736 5.87309C17.212 5.73462 17.3861 5.66379 17.5957 5.66059C17.8053 5.65737 17.9825 5.7282 18.1274 5.87309C18.2723 6.01795 18.3447 6.19359 18.3447 6.39999C18.3447 6.60639 18.2723 6.78202 18.1274 6.92689L13.0543 12L18.1274 17.0731C18.2658 17.2115 18.3367 17.3856 18.3399 17.5952C18.3431 17.8048 18.2723 17.982 18.1274 18.1269C17.9825 18.2718 17.8069 18.3442 17.6005 18.3442C17.3941 18.3442 17.2184 18.2718 17.0736 18.1269L12.0005 13.0538Z"
                                    fill="#5C6B79" />
                            </g>
                        </svg>
                    </div>
                </div>
                <div class="pl-[20px] pr-[20px] mt-[24px]">
                    <div class="center mt-[14px]">
                        <vs-table>
                            <template #thead>
                                <vs-tr>
                                    <vs-th><div class="text-custom">วันที่ประกาศ</div></vs-th>
                                    <vs-th><div class="text-custom">วันที่สิ้นสุด</div></vs-th>
                                    <vs-th><div class="text-custom">เรื่องที่ประกาศ</div></vs-th>
                                    <vs-th><div class="text-custom">รายละเอียด</div></vs-th>
                                    <vs-th><div class="text-custom">รูปภาพ</div></vs-th>
                                    <vs-th><div class="text-custom">ผู้สร้างประกาศ</div></vs-th>
                                </vs-tr>
                            </template>
                            <template #tbody>
                                <vs-tr :key="tr.id" v-for="tr in expiredAnnouncements" :data="tr">
                                    <vs-td>
                                        <div class="text-custom">{{ convertDateNoTime(tr.attributes.createdAt) }}</div>
                                    </vs-td>
                                    <vs-td>
                                        <div class="text-custom">{{ convertDateNoTime(tr.attributes.date_execute) }}</div>
                                    </vs-td>
                                    <vs-td>
                                        <div class="text-custom">{{ tr.attributes.topic }}</div>
                                    </vs-td>
                                    <vs-td>
                                        <div class="text-custom">{{ tr.attributes.description }}</div>
                                    </vs-td>
                                    <vs-td>
                                        <div class="flex items-center">
                                            <img v-for="img in announcementImages(tr)" :key="img.id" :src="img.thumb"
                                                @click="previewImg(img.full)"
                                                class="h-[36px] w-[36px] object-cover rounded-[6px] border mr-[4px] cursor-pointer" />
                                            <span v-if="announcementImages(tr).length === 0" class="text-custom text-[#5C6B79]">-</span>
                                        </div>
                                    </vs-td>
                                    <vs-td>
                                        <div class="text-custom flex">
                                            <Avatar
                                                :src="tr.attributes.users_created && tr.attributes.users_created.data && tr.attributes.users_created.data.attributes.imageProfile && tr.attributes.users_created.data.attributes.imageProfile.data && tr.attributes.users_created.data.attributes.imageProfile.data.attributes.url"
                                                :name="tr.attributes.users_created && tr.attributes.users_created.data ? ((tr.attributes.users_created.data.attributes.firstName || '') + ' ' + (tr.attributes.users_created.data.attributes.lastName || '')) : ''"
                                                :size="32" />
                                            <div class="flex justify-center items-center ml-[8px]">
                                                {{ tr.attributes.users_created?.data?.attributes?.firstName }}
                                                {{ tr.attributes.users_created?.data?.attributes?.lastName }}
                                            </div>
                                        </div>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                        <div v-if="expiredAnnouncements.length === 0"
                            class="text-custom text-center text-[#5C6B79] py-[16px]">ไม่มีประกาศที่หมดอายุ</div>
                    </div>
                </div>
            </div>
        </b-modal>

        <!-- Delete Confirmation Dialog -->
        <vs-dialog width="550px" not-center v-model="delete_popup">
            <div class="text-custom mt-[12px]">
                <p class="text-[18px] font-bold text-center">
                    ต้องการลบประกาศ {{ deleteTargets.length }} รายการหรือไม่?
                </p>
                <ul class="mt-[12px] mb-[8px] max-h-[180px] overflow-y-auto">
                    <li v-for="t in deleteTargets" :key="t.id" class="text-[14px] py-[2px] border-b">
                        {{ t.attributes.topic || '(ไม่มีหัวข้อ)' }}
                        <span class="text-[#5C6B79] text-[12px]">— สิ้นสุด {{ convertDateNoTime(t.attributes.date_execute) }}</span>
                    </li>
                </ul>
            </div>
            <template #footer>
                <div class="con-footer flex justify-between">
                    <vs-button @click="delete_popup = false" :disabled="deleting" dark transparent>
                        <div class="flex items-center">ยกเลิก</div>
                    </vs-button>
                    <div class="h-[36px] pl-[12px] pr-[12px] bg-[#D44769] flex cursor-pointer justify-center rounded-[12px]"
                        :class="deleting ? 'opacity-50 pointer-events-none' : ''">
                        <div class="text-white font-bold flex justify-center items-center" @click="deleteAnnouncement()">
                            ยืนยันการลบ
                        </div>
                    </div>
                </div>
            </template>
        </vs-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import router from '@/router'
import { convertDateNoTime } from '@/components/hook/hook'

export default {
    data() {
        return {
            tab: 1,
            popup_filter: false,
            topic: "",
            description: "",
            date_execute: "",
            allCheck: false,
            selected: [],
            announcement: [],
            image_name: '',
            image: [],
            image_e: [],
            create_ann: false,
            history_ann: false,
            delete_popup: false,
            creating: false,
            // edit
            edit_ann: false,
            saving: false,
            editId: null,
            editTopic: "",
            editDescription: "",
            editDateExecute: "",
            editExistingImages: [],
            editNewImage: null,
            editNewImageName: "",
            editNewImagePreview: "",
            // delete
            deleteTargets: [],
            deleting: false,
            convertDateNoTime,
            currentMonthAnnouncementCount: 0,
            BUSINESS_PACKAGE_ANNOUNCEMENT_LIMIT: 5,
        }
    },
    
    created() {
        this.$store.state.main = true
        const loading = this.$vs.loading({
            color: '#003765',
            opacity: 1,
        })
        setTimeout(() => {
            loading.close()
        }, 1000)
    },
    
    computed: {
        // Newest first (defensive - the API already sorts id:desc, but don't rely on it).
        sortedAnnouncements() {
            return [...this.announcement].sort((a, b) => {
                return new Date(b?.attributes?.createdAt || 0) - new Date(a?.attributes?.createdAt || 0);
            });
        },

        // Active = end date (date_execute) has not fully passed yet. Shown in the main table.
        activeAnnouncements() {
            return this.sortedAnnouncements.filter((a) => !this.isExpired(a));
        },

        // Expired = end date is in the past. Shown in the history modal.
        expiredAnnouncements() {
            return this.sortedAnnouncements.filter((a) => this.isExpired(a));
        },

        packageId() {
            return this.$store.state.buildingInfo[0]?.attributes?.package?.data?.id;
        },
        
        isBusinessPackage() {
            return this.packageId === 1; // Business package - 5 announcements per month
        },
        
        isProPackage() {
            return this.packageId === 2; // Pro package - unlimited announcements
        },
        
        canCreateAnnouncement() {
            if (this.isProPackage) {
                return true; // No limit for Pro package
            }
            
            if (this.isBusinessPackage) {
                return this.currentMonthAnnouncementCount < this.BUSINESS_PACKAGE_ANNOUNCEMENT_LIMIT;
            }
            
            // If user doesn't have package ID 1 or 2, they can't create announcements
            return false;
        },
        
        remainingAnnouncements() {
            if (this.isProPackage) {
                return null; // No limit
            }
            
            if (this.isBusinessPackage) {
                return Math.max(0, this.BUSINESS_PACKAGE_ANNOUNCEMENT_LIMIT - this.currentMonthAnnouncementCount);
            }
            
            return 0;
        }
    },
    
    mounted() {
        this.getAnnouncement();
    },
    
    methods: {
        getCurrentMonthAnnouncementCount() {
            const now = new Date();
            const currentMonth = now.getMonth() + 1;
            const currentYear = now.getFullYear();
            
            const currentMonthAnnouncements = this.announcement.filter(announcement => {
                const createdDate = new Date(announcement.attributes.createdAt);
                return createdDate.getMonth() + 1 === currentMonth && 
                       createdDate.getFullYear() === currentYear;
            });
            
            this.currentMonthAnnouncementCount = currentMonthAnnouncements.length;
            return this.currentMonthAnnouncementCount;
        },
        
        checkAnnouncementLimit() {
            if (!this.canCreateAnnouncement) {
                if (this.isBusinessPackage) {
                    this.$vs.notification({
                        title: 'จำกัดการสร้างประกาศ',
                        text: `คุณสร้างประกาศได้เพียง ${this.BUSINESS_PACKAGE_ANNOUNCEMENT_LIMIT} ครั้งต่อเดือน (เหลือ ${this.remainingAnnouncements} ครั้ง)`,
                        color: 'warning',
                        position: 'top-right'
                    });
                    return false;
                } else {
                    this.$vs.notification({
                        title: 'อัพเกรดแพ็คเกจ',
                        text: 'ฟีเจอร์นี้ใช้ได้กับแพ็คเกจ Business และ Professional เท่านั้น',
                        color: 'danger',
                        position: 'top-right'
                    });
                    return false;
                }
            }
            return true;
        },
        
        handleCreateAnnouncement() {
            if (!this.checkAnnouncementLimit()) {
                return;
            }
            // Clear form fields
            this.topic = "";
            this.description = "";
            this.date_execute = "";
            this.image = [];
            this.image_name = "";
            this.image_e = [];
            // Show create announcement modal
            this.create_ann = true;
        },
        
        isExpired(a) {
            const end = a?.attributes?.date_execute;
            if (!end) return false;
            const endDate = new Date(end);
            if (isNaN(endDate.getTime())) return false;
            // date_execute is the last day the announcement is valid - it stays
            // active through the end of that calendar day.
            endDate.setHours(23, 59, 59, 999);
            return endDate.getTime() < Date.now();
        },

        announcementImages(tr) {
            const data = tr?.attributes?.image?.data;
            if (!Array.isArray(data)) return [];
            return data.map((img) => {
                const attr = img?.attributes || {};
                const path = attr.formats?.thumbnail?.url || attr.url || '';
                const full = attr.url || '';
                return {
                    id: img.id,
                    name: attr.name,
                    thumb: path ? 'https://api.resguru.app' + path : '',
                    full: full ? 'https://api.resguru.app' + full : '',
                };
            }).filter((img) => img.thumb);
        },

        previewImg(url) {
            if (url) window.open(url, '_blank');
        },

        hasSelectedImage() {
            return this.image instanceof File || (Array.isArray(this.image) && this.image.length > 0);
        },

        getAnnouncement() {
            const loading = this.$vs.loading()
            return fetch(`https://api.resguru.app/api/announcements?filters[building][id][$eq]=${this.$store.state.building}&populate=*&sort[0]=id:desc`)
                .then(response => response.json())
                .then((resp) => {
                    console.log("Return from getAnnouncement()", resp.data);
                    this.announcement = Array.isArray(resp.data) ? resp.data : [];
                    // Calculate current month count after fetching
                    this.getCurrentMonthAnnouncementCount();
                }).catch((error) => {
                    const errorMessage = this.$errMsg(error, 'โหลดข้อมูลประกาศ');
                    this.$showNotification("danger", errorMessage);
                }).finally(() => {
                    loading.close()
                })
        },
        
        async createAnnouncement() {
            // Check limit before creating
            if (!this.checkAnnouncementLimit()) {
                return;
            }

            if (!this.topic || !this.description || !this.date_execute || !this.hasSelectedImage()) {
                this.$showNotification('danger', 'กรุณากรอกข้อมูลให้ครบถ้วน');
                return;
            }

            this.creating = true;
            try {
                const resp = await axios.post('https://api.resguru.app/api/announcements', {
                    data: {
                        topic: this.topic,
                        description: this.description,
                        date_execute: this.toDateExecute(this.date_execute),
                        users_created: this.$store.state.userInfo.id,
                        building: this.$store.state.building
                    }
                });

                // Attach the image and wait for it - only report success once it lands.
                if (this.hasSelectedImage()) {
                    const formData = new FormData();
                    formData.append("files", this.image);
                    formData.append("refId", String(resp.data.data.id));
                    formData.append("ref", "api::announcement.announcement");
                    formData.append("field", "image");

                    await axios.post("https://api.resguru.app/api/upload", formData, {
                        headers: { "Content-Type": "multipart/form-data" },
                    });
                }

                this.$showNotification('#3A89CB', 'สร้างประกาศสำเร็จ');
                this.create_ann = false;
                await this.getAnnouncement();
            } catch (error) {
                const errorMessage = 'พบข้อผิดพลาดในการอัพเดทข้อมูล';
                this.$showNotification('danger', errorMessage);
            } finally {
                this.creating = false;
            }
        },

        previewImage(event) {
            const file = event.target.files && event.target.files[0];
            if (!file) return;
            this.image = file;
            this.image_name = file.name;
            const reader = new FileReader();
            reader.onload = (e) => {
                this.image_e = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        
        toDateInput(dt) {
            if (!dt) return "";
            const d = new Date(dt);
            if (isNaN(d.getTime())) return "";
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${y}-${m}-${day}`;
        },
        // date_execute is a Strapi `datetime` field - send a full ISO string
        // (a bare YYYY-MM-DD is the ambiguous case the backend warns about).
        toDateExecute(v) {
            if (!v) return null;
            const d = new Date(v);
            return isNaN(d.getTime()) ? null : d.toISOString();
        },

        openEditAnnouncement(tr) {
            this.editId = tr.id;
            this.editTopic = tr.attributes.topic || "";
            this.editDescription = tr.attributes.description || "";
            this.editDateExecute = this.toDateInput(tr.attributes.date_execute);
            this.editExistingImages = this.announcementImages(tr);
            this.editNewImage = null;
            this.editNewImageName = "";
            this.editNewImagePreview = "";
            this.edit_ann = true;
        },

        previewEditImage(event) {
            const file = event.target.files && event.target.files[0];
            if (!file) return;
            this.editNewImage = file;
            this.editNewImageName = file.name;
            const reader = new FileReader();
            reader.onload = (e) => { this.editNewImagePreview = e.target.result; };
            reader.readAsDataURL(file);
        },

        clearEditNewImage() {
            this.editNewImage = null;
            this.editNewImageName = "";
            this.editNewImagePreview = "";
        },

        async updateAnnouncement() {
            if (!this.editTopic || !this.editDescription || !this.editDateExecute) {
                this.$showNotification('danger', 'กรุณากรอกข้อมูลให้ครบถ้วน');
                return;
            }

            this.saving = true;
            try {
                await axios.put('https://api.resguru.app/api/announcements/' + this.editId, {
                    data: {
                        topic: this.editTopic,
                        description: this.editDescription,
                        date_execute: this.toDateExecute(this.editDateExecute),
                    }
                });

                if (this.editNewImage) {
                    const formData = new FormData();
                    formData.append("files", this.editNewImage);
                    formData.append("refId", String(this.editId));
                    formData.append("ref", "api::announcement.announcement");
                    formData.append("field", "image");
                    await axios.post("https://api.resguru.app/api/upload", formData, {
                        headers: { "Content-Type": "multipart/form-data" },
                    });
                }

                this.$showNotification('#3A89CB', 'แก้ไขประกาศสำเร็จ');
                this.edit_ann = false;
                await this.getAnnouncement();
            } catch (error) {
                const errorMessage = 'พบข้อผิดพลาดในการแก้ไขข้อมูล';
                this.$showNotification('danger', errorMessage);
            } finally {
                this.saving = false;
            }
        },

        confirmDeleteAnnouncement(tr) {
            this.deleteTargets = [tr];
            this.delete_popup = true;
        },

        confirmDeleteSelected() {
            if (!this.selected.length) return;
            this.deleteTargets = [...this.selected];
            this.delete_popup = true;
        },

        async deleteAnnouncement() {
            if (!this.deleteTargets.length) {
                this.delete_popup = false;
                return;
            }

            this.deleting = true;
            const loading = this.$vs.loading({ color: '#003765' });
            try {
                const results = await Promise.allSettled(
                    this.deleteTargets.map((el) =>
                        axios.delete('https://api.resguru.app/api/announcements/' + el.id)
                    )
                );
                const failed = results.filter((r) => r.status === 'rejected').length;
                const ok = results.length - failed;

                if (ok) this.$showNotification('warn', `ลบประกาศสำเร็จ ${ok} รายการ`);
                if (failed) this.$showNotification('danger', `ลบไม่สำเร็จ ${failed} รายการ`);

                this.selected = [];
                this.allCheck = false;
                this.deleteTargets = [];
                this.delete_popup = false;
                await this.getAnnouncement();
            } finally {
                this.deleting = false;
                loading.close();
            }
        }
    }
}
</script>

<style>
.text-custom {
    font-family: 'Prompt';
}

.cursor-not-allowed {
    cursor: not-allowed !important;
}

.bg-gray-400 {
    background-color: #9CA3AF;
}
</style>